import Conf from '../conf/auth.json';
import ConfApi from '../conf/back.json';
import { Buffer } from 'buffer';

let access_token = null;

let user_info = null;

const PERSISTENTS_STORAGE = {
  token: 'access_token',
  user_info: 'user_info'
};

export const constr_uri = (endpoint)=>`/${ConfApi.version}/${endpoint}`;

const buildOAuthUrl = () => {
    const {
      oauthUrl,
      clientId,
      redirectUri,
      scope = 'openid profile email',
      responseType = 'code'
    } = Conf.oauthConfig;

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: responseType,
      scope: scope,
      state: Math.random().toString(36).substring(2), // CSRF protection
      
      ...Conf.oauthConfig.additionalParams
    });

    return `${oauthUrl}?${params.toString()}`;
};


export const handleLogin = () => {
  const oauthUrl = buildOAuthUrl();
  window.location.href = oauthUrl;
};

export const setAuthToken = (token) => {

  access_token = token;
  
  if (token) {
    localStorage.setItem(PERSISTENTS_STORAGE.token, token);
  } else {
    localStorage.removeItem(PERSISTENTS_STORAGE.token);
  }
};

export const setUserInfo = (userInfo)=>{

  user_info = userInfo;

  if (userInfo) {
    localStorage.setItem(PERSISTENTS_STORAGE.user_info, JSON.stringify(userInfo));
  } else {
    localStorage.removeItem(PERSISTENTS_STORAGE.token);
  }
}

export const getUserInfo = () => {
  
  if(user_info) return user_info
  
  const storage = localStorage.getItem(PERSISTENTS_STORAGE.user_info);

  if(storage) return JSON.parse(storage);

  return null;

};

export const initNewToken = async (code) => {
    
      if (code) {
        try {
          
          const tokenResponse = await fetch(Conf.oauthConfig.tokenUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              grant_type: 'authorization_code',
              code: code,
              client_id: Conf.oauthConfig.clientId,
              redirect_uri: Conf.oauthConfig.redirectUri,
              // client_secret если требуется
            }),
          });

          const tokenData = await tokenResponse.json();

          if(tokenData.error && tokenData.error.code && tokenData.error.code == 1006) {

            alert(`Модуль авторизації (зовнішня система) не повернув ідентифікатор користувача разом з верифікованою адресою електронної пошти.`);

            return tokenData.error;
          }
          
          if (tokenData.data && tokenData.data.token) {

            const user_info = {
              user: tokenData.data.user,
              privilegedUser: tokenData.data.privilegedUser,
              auth_type: tokenData.data.auth_type,
              expDate: tokenData.data.expDate
            }

            setAuthToken(tokenData.data.token);
            setUserInfo(user_info);
            
            return tokenData.data;
           
          }
        } catch (error) {
          console.error('Token exchange error:', error);
          return error;
        }
      }
}

export const getAuthToken = () => {
  return access_token || localStorage.getItem(PERSISTENTS_STORAGE.token);
};

const apiClient = {
  async request(url, options = {}) {
    const token = getAuthToken();
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      headers['token'] = `${token}`;
    }

    const response = await fetch(constr_uri(url), {
      ...options,
      headers,
    });

    if(response.status == 401) handleLogin();

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  get(url) {
    return this.request(url);
  },

  post(url, data) {
    return this.request(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  put(url, data) {
    return this.request(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  patch(url, data) {
    return this.request(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  delete(url) {
    return this.request(url, {
      method: 'DELETE',
    });
  },
};

export const apiSendFileHeader = async (url, file, desc)=>{

  const finfHeader = Buffer.from(JSON.stringify(desc)).toString('base64');

  const token = getAuthToken();

  const headers = {
      'Content-Type': 'application/octet-stream',
      'finf': finfHeader
  };

    if (token) {
      headers['token'] = `${token}`;
    }
  

  try{

    const response = await fetch(constr_uri(url),{
      method: 'PUT',
      headers,
      body: file
    })

    return response
  } catch(err){

    return ({ error: err})
  }
  
  
}

export const downloadFile = async (url, fileName=null, typeReq='get')=>{

  const token = getAuthToken();

  const headers = { token };

  const options = { headers };

  if(typeReq !== 'get'){
    options['method'] = 'post';

    options['headers']['Content-type'] = 'application/json';

    options['body'] = JSON.stringify({ name_instruction: fileName })
  }

  const response = await fetch(constr_uri(url), options);

  const contentType = response.headers.get("content-type");
  const contentDisposition = response.headers.get("content-disposition");

  const name_from_server = contentDisposition?.split("filename=") && decodeURI(contentDisposition?.split("filename=")[1]) || null;


  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download =  fileName || name_from_server || 'file' ;
    link.click();
    window.URL.revokeObjectURL(url);
  }
  
  return response;
}


export const loadFileAsBase64 = async (url,  mime) => {


  const token = getAuthToken();
  const headers = { token };

  try {
    const response = await fetch(constr_uri(url), { headers });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = () => {
        reject(new Error('Failed to convert blob to Base64'));
      };
      reader.readAsDataURL( mime ? blob.slice(0, blob.size, mime) : blob);
    });
  } catch (error) {
    console.error('Error loading file:', error);
    throw error;
  }
};

export const loadFileAsBlob = async (url) => {


  const token = getAuthToken();
  const headers = { token };

  try {
    const response = await fetch(constr_uri(url), { headers });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    
   return blob;

   
  } catch (error) {
    console.error('Error loading file:', error);
    throw error;
  }
};

export default apiClient;